module.exports = __webpack_public_path__ + "media/vraag_1_antwoord.2a1bc5dd.mp3";